import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

// context
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const ShareDocuments = () => {
  const { docId, groupId } = useParams();
  const { isAnyServiceUser, isForeignCA } = useRoleBasedView();

  useEffect(() => {
    if (isForeignCA) {
      window.location.href = `${window.location.origin}/practice/crm/${groupId}/documents/${docId}`;
      return;
    }

    if (isAnyServiceUser) {
      window.location.href = `${window.location.origin}/admin/crm/${groupId}/documents/${docId}`;
      return;
    }

    window.location.href = `${window.location.origin}/tax/documents/${docId}`;
    return;
  }, []);

  return <></>;
};
